

import React, { memo } from 'react';
import CommentsContext from '../../../../../contexts/commentsContext';
import PureIndicators from '../components/Indicators';









function Indicators(props) {
  const { comments, isV2Design } = props;

  return (
    <CommentsContext.Consumer>
      {({ state: { userAssignedColors } }) =>
      <PureIndicators
        {...props}
        comments={comments}
        isV2Design={isV2Design}
        userAssignedColors={userAssignedColors} />}


    </CommentsContext.Consumer>);

}

export default memo(Indicators);